import {css, styled} from 'styled-components'

export const StyledAgendaSidebarDottedDivider = styled.div(
    ({theme: {palette}}) => css`
        width: 100%;
        border-bottom: 2px dotted ${palette.neutral['200']};
    `
)
